// extracted by mini-css-extract-plugin
export default {"loadAction":"TsaZas","borderBottom":"Vz7eVi"};